import { Icon } from "@iconify/react";
import React, { useState } from "react";
export const Accordion = (props) => {
    const { children, title, isOpen, helpText } = props;
    const [isExpanded, setIsExpanded] = useState(isOpen ?? false);
    return (React.createElement("div", { className: "rounded-2xl border border-neutral-gray p-4" },
        React.createElement("div", { className: "w-full flex justify-between" },
            React.createElement("div", { className: "flex items-center gap-2" },
                React.createElement("div", { className: "text-lg my-auto" }, title),
                helpText && (React.createElement("div", { title: helpText },
                    React.createElement(Icon, { icon: "material-symbols:exclamation", width: "20", height: "20", className: "rounded-full border border-black" })))),
            React.createElement("button", { onClick: () => setIsExpanded(!isExpanded) },
                React.createElement("div", { className: "transition-all ease-out duration-300" },
                    React.createElement(Icon, { icon: "lucide:chevron-right", width: "24", height: "24", className: `transition-transform ${isExpanded ? "rotate-90" : "rotate-0"}` })))),
        isExpanded && children));
};
